import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';

const PaymentMethod = (props) => {
  const { reservation } = props;
  if (!reservation.customerCreditCard) {
    return null;
  }
  return (
    <span className="c7-account__credit-card">
      <strong>Payment method</strong>
      <br />
      <CreditCardDisplay creditCard={reservation.customerCreditCard} />
    </span>
  );
};

export default PaymentMethod;
